/* global jQuery */
import React, { PropTypes } from 'react'
import { connect }          from 'react-redux'
//import { push }             from 'react-router-redux'
//import qs                   from 'query-string'
import { getGeoLocation }   from '../actions/api'
import { updateTimeZone }   from '../actions'
import ads                  from '../lib/utils/ads'
import meta                 from '../lib/utils/meta'
import webviews             from '../lib/utils/webviews'
import shell                from '../lib/utils/shell'
import debounce             from '../lib/utils/debounce'
import dateFormat           from '../lib/utils/dateformat'
import { setDeviceType }    from '../actions/utils'
import mapPageToTemplate    from '../../reduxion-core/lib/mapPageToTemplate'
import { bindRouterPush }   from '../actions/utils'

@connect(state => {
  return { ...state.page }
}, dispatch => {
  return { dispatch, routerPush : bindRouterPush(dispatch) }
})

export default class App extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.object
  }

  constructor() {
    super()
    this.handleResize = this.handleResize.bind(this)
    this.state = {
      width : 0
    }
  }
  
  initResizeEvent() {
    try{
      jQuery(window).resize( debounce( this.handleResize, 500 ) )
      this.handleResize()
    } catch(e) {
      /* Intentionally ignored error */
    }
  }

  handleResize() {
    let currentWidth = jQuery(window).outerWidth()    
    if( this.state.width !== currentWidth ) {
      this.setState({ width: currentWidth })
      this.props.dispatch( setDeviceType( currentWidth ) )
    }
  }
  
  postRenderHooks() {
    const { params = {}, ads, analytics, tier3Nav, tier2Nav } = this.props
    const { pageType, sport } = params
    const template = mapPageToTemplate({ pageType, sport })

    shell.transition.postRender(sport, template, ads, analytics, tier3Nav, tier2Nav)
  }

  componentDidMount() {
    const { edition, location, params } = this.props
    this.props.dispatch( getGeoLocation( params, location.query || {} , true ) ) /* Call action to get geo details to filter videos */ 
    this.initResizeEvent()
    if( edition.timeZoneDomain !== dateFormat.getLocalTimezone() ) {
      this.props.dispatch( updateTimeZone() )    
    }
    this.postRenderHooks()     
  }

  componentDidUpdate() {
    this.postRenderHooks()
  }

  render() {
    const { edition, location, routerPush, appProps, isFastcastAllowed } = this.props    
    const pageURL = `http://${edition.domain}${location.pathname+location.search}`
    return React.cloneElement(this.props.children, { params: this.props.params, ads: ads, updateMeta: meta.update, webviews: webviews, pageURL: pageURL, routerPush: routerPush, appProps: appProps, isFastcastAllowed: isFastcastAllowed })
  }
}



/** WEBPACK FOOTER **
 ** ../app/containers/App.jsx
 **/